import React, { useEffect, useState, useLayoutEffect, useReducer } from 'react';
import './style/index.jsx'
import { LoginContext } from './context/loginContext.jsx';
import MainRoutes from './root.jsx';
import LoginReducer from './pages/login/loginReducer.jsx';
import GlkFooter from './components/Footer/GlkFooter.jsx';
import { getMemberDetails } from './pages/login/loginService.jsx';
import BackToTopButton from './components/backToTopButton.jsx';
import HeaderReducer from './components/Header/headerReducer.jsx';

function App() {
  const [isTokenExpired, setIsTokenExpired] = useState(false);
  const [stickyClass, setStickyClass] = useState("");

let initialValues = {
  memberLogin : null,
  memberDetails :null,
  accessToken: null,
  currentUrl: null,
  isConfirmMailPopup: true, 
  isTestInformation: true, 
  language: 'de',
  messageCount: 0,
  refreshMenubar: false
}

  const [loginData, dispatch] = useReducer(
    LoginReducer,
    initialValues
  );  

  let headerPropsInitialValue = {
    showMenubar: true,
    step: '',
    myProfileUrl:'',
    isPreRegistration: false,
    isMessenger: '',
    isSuggestion: '',
  }

    const [headerProps, headerDispatch] = useReducer(
    HeaderReducer,
    headerPropsInitialValue
  );  


  let accessToken = localStorage.getItem('accessToken')
  useEffect(() => {
    dispatch({ type: 'ACCESS_TOKEN', data: accessToken })
    if (accessToken) {      
      getMemberDetails(accessToken).then((response) => {
        if (response?.status == 200) {
          dispatch({ type: 'MEMBER_DETAILS', data: response.data })
        }
        else if(response?.status == 401) {
          localStorage.removeItem('accessToken');
          dispatch({ type: 'LOGIN', data: null });
          dispatch({ type: 'MEMBER_DETAILS', data: null });
          setIsTokenExpired(true)
        }
    })
  }
}, []);

  useEffect(() => {
    if (!window.name) {
      window.name = Math.random().toString(36).slice(2, 9);
    }
    const handleStorage = (event) => {
      if (event.key === "force_refresh") {
        const data = JSON.parse(event.newValue);
        const source = data?.source;
        if (source !== window.name) {
          // This tab is not the one that triggered the update so reload
          window.location.reload();
        }
      }
      if (event.key === "logout-event") {
        localStorage.removeItem('accessToken');

        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/teilnehmer/login';
        }
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);  

  }, []);

  useEffect(() => {
    let language = localStorage.getItem('language')    
    document.documentElement.lang = language || 'de'; 

  }, [loginData.language]);

  
  useLayoutEffect(() => {    
    if (window.location.pathname.split("/").pop() == 'messenger') {
      setStickyClass("messenger");
    } else {
      setStickyClass("");
    }
    document.documentElement.style.overflowY = 'auto';
  }, [location.pathname]);  

  useEffect(() => {
    if (!window.visualViewport) return;

    const updateViewport = () => {
      document.documentElement.style.setProperty(
        "--vv-top",
        window.visualViewport.offsetTop + "px"
      );
      document.documentElement.style.setProperty(
        "--vv-height",
        window.visualViewport.height + "px"
      );
    };

    window.visualViewport.addEventListener("resize", updateViewport);
    window.visualViewport.addEventListener("scroll", updateViewport);

    updateViewport();

    return () => {
      window.visualViewport.removeEventListener("resize", updateViewport);
      window.visualViewport.removeEventListener("scroll", updateViewport);
    };
  }, []);

  return (
    <LoginContext.Provider value={{ loginData, dispatch, headerDispatch, headerProps} }>
      
      <div className={"App "+stickyClass}>        
        <MainRoutes isTokenExpired={isTokenExpired}/>
        {accessToken ? <GlkFooter /> : null}
        <BackToTopButton />
      </div>
    </LoginContext.Provider>
  );
}

export default App;
